import client from './base'

export interface ExternalLawyer {
  id: string
  name: string
  email: string | null
  is_active: boolean
  is_external: true
  created_at: string
}

export interface ExternalLawyerInput {
  name: string
  email?: string | null
}

export interface ExternalLawyersListParams {
  limit?: number
  offset?: number
}

export interface ExternalLawyersListResponse {
  count: number
  next: string | null
  previous: string | null
  results: ExternalLawyer[]
}

export const externalLawyersService = {
  list: async (params?: ExternalLawyersListParams): Promise<ExternalLawyersListResponse> => {
    const res = await client.get<ExternalLawyersListResponse>('/api/v1/external-lawyers/', { params })
    return res.data
  },

  create: async (data: ExternalLawyerInput): Promise<ExternalLawyer> => {
    const res = await client.post<ExternalLawyer>('/api/v1/external-lawyers/', data)
    return res.data
  },

  update: async (id: string, data: ExternalLawyerInput): Promise<ExternalLawyer> => {
    const res = await client.patch<ExternalLawyer>(`/api/v1/external-lawyers/${id}/`, data)
    return res.data
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/api/v1/external-lawyers/${id}/`)
  },
}
